<div *ngIf="activeToggle == 'Tabular'">
  <ngx-datatable
    class="material widthDatatable"
    [rows]="timelineData"
    [columns]="displayColumnsTimeline"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [limit]="5"
    [scrollbarH]="true"
  >
  </ngx-datatable>
</div>
<div *ngIf="activeToggle == 'Graphical'" style="text-align: 'center'">
  Graphical
</div>
